import {
	SET_ADVISORS,
	SET_INFO,
	SET_STUDENTS,
	UPDATE_STUDENTS,
} from "./actions";

const initialState = {
	advisors: [],
	students: [],
	info: {},
};

const reportReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_ADVISORS:
			return { ...state, advisors: action.advisors };
		case SET_STUDENTS:
			return { ...state, students: action.students };
		case UPDATE_STUDENTS:
			const copyStudents = [...state.students];
			copyStudents.forEach(s => {
				const findStudent = action.students.find(student => student.id === s.id);
				if (findStudent) {
					s.class = findStudent.class;
				}
			});

			return { ...state, students: copyStudents };
		case SET_INFO:
			return { ...state, info: action.info };
		default:
			return state;
	}
};

export default reportReducer;
